export const SUMMARY_CARD_TYPES = {
    ACTIVITY: 'Activity',
    PRICING: 'Pricing',
    AUTOMATION: 'Automation',
};

export const SUMMARY_STATUS = {
    CONFIGURED: 'Configured',
    SKIPPED: 'Skipped',
    NOT_MODIFIED: 'Not Modified',
    MODIFIED: 'Modified',
};
